import React, { Component } from 'react';
import TableText from "../../../table/TableText";
import moment from "moment";

export const columnsData = (data, date, print) => {
    const totalIndex = [...new Array(moment(date).daysInMonth()).fill(1).map((x, i) => i + 1).filter(x => moment(date + `-${x}`).format('E') > 5).map(x => x - 1), moment(date).daysInMonth()]

    return [{
        title: moment(date).format('YY-MMM'),
        key: 'day',
        align: "center",
        dataIndex: 'day',
        fixed: print ? false : "left",
        width: 70,
        render: (text, record, index) => {
            return (
                <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `} style={{ textAlign: "left" }}>
                    {text}
                </div >
            )
        }
    }, ...data.map((x, i) => {
        return {
            title: <span>{x.name.replace(/[^a-zA-Z0-9\s]/g, '')}<br />{x.name.replace(/[^\u4E00-\u9FA5]/g, "")}</span>,
            align: "center",
            children: [, {
                title: 'Available',
                dataIndex: `${x.code || i * i}available`,
                key: `${x.code || i * i}available`,
                align: "center",
                width: 100,
                render: (text, record, index) => {
                    const props = {
                        text: text || 0,
                        index,
                        type: "number",
                        name: x.key,
                        totalIndex,
                    };

                    return (
                        <TableText data={{ ...props }} />
                    )
                }
            }, {
                    title: 'Occupied',
                    dataIndex: `${x.code || i * i}occupied`,
                    key: `${x.code || i * i}occupied`,
                    align: "center",
                    width: 100,
                    render: (text, record, index) => {
                        const props = {
                            text: text || 0,
                            index,
                            type: "number",
                            name: x.key,
                            totalIndex,
                        };

                        return (
                            <TableText data={{ ...props }} />
                        )
                    }
                }, {
                    title: '%',
                    dataIndex: `${x.code || i * i}occ`,
                    key: `${x.code || i * i}occ`,
                    align: "center",
                    width: 100,
                    render: (text, record, index) => {
                        const props = {
                            text: text || 0,
                            index,
                            type: "percent",
                            name: x.key,
                            totalIndex,
                        };

                        return (
                            <TableText data={{ ...props }} />
                        )
                    }
                }, {
                    title: 'ADR',
                    dataIndex: `${x.code || i * i}arr`,
                    key: `${x.code || i * i}arr`,
                    align: "center",
                    width: 100,
                    render: (text, record, index) => {
                        const props = {
                            text: text || 0,
                            index,
                            type: "number",
                            name: x.key,
                            totalIndex,
                        };

                        return (
                            <TableText data={{ ...props }} />
                        )
                    }
                }, {
                    title: 'RevPAR',
                    dataIndex: `${x.code || i * i}revpar`,
                    key: `${x.code || i * i}revpar`,
                    align: "center",
                    width: 100,
                    render: (text, record, index) => {
                        const props = {
                            text: text || 0,
                            index,
                            type: "number",
                            name: x.key,
                            totalIndex,
                        };

                        return (
                            <TableText data={{ ...props }} />
                        )
                    }
                }, {
                    title: 'Rm Rev',
                    dataIndex: `${x.code || i * i}rev`,
                    key: `${x.code || i * i}rev`,
                    align: "center",
                    width: 100,
                    render: (text, record, index) => {
                        const props = {
                            text: text || 0,
                            index,
                            type: "number",
                            name: x.key,
                            totalIndex,
                        };

                        return (
                            <TableText data={{ ...props }} />
                        )
                    }
                }, {
                    title: 'F&B',
                    dataIndex: `${x.code || i * i}fb`,
                    key: `${x.code || i * i}fb`,
                    align: "center",
                    width: 100,
                    render: (text, record, index) => {
                        const props = {
                            text: text || 0,
                            index,
                            type: "number",
                            name: x.key,
                            totalIndex,
                        };

                        return (
                            <TableText data={{ ...props }} />
                        )
                    }
                }, {
                    title: 'TTL Rev',
                    dataIndex: `${x.code || i * i}total`,
                    key: `${x.code || i * i}total`,
                    align: "center",
                    width: 100,
                    render: (text, record, index) => {
                        const props = {
                            text: text || 0,
                            index,
                            type: "number",
                            name: x.key,
                            totalIndex,
                        };

                        return (
                            <TableText data={{ ...props }} />
                        )
                    }
                }]
        }
    })]
}


// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/daily/1.3/data.js